const STORAGE_KEY = "billsplit.apiKey";

const getStorage = (): Storage | null => {
  if (typeof window === "undefined" || !window.localStorage) {
    return null;
  }
  return window.localStorage;
};

export const getStoredApiKey = (): string | null => {
  const storage = getStorage();
  return storage ? storage.getItem(STORAGE_KEY) : null;
};

export const setStoredApiKey = (key: string) => {
  const storage = getStorage();
  storage?.setItem(STORAGE_KEY, key);
};

export const clearStoredApiKey = () => {
  const storage = getStorage();
  storage?.removeItem(STORAGE_KEY);
};

export const syncApiKeyFromUrl = (): string | null => {
  if (typeof window === "undefined") {
    return null;
  }
  const { search, pathname, hash } = window.location;
  const params = new URLSearchParams(search);
  const key = params.get("key");
  if (!key) {
    return null;
  }
  params.delete("key");
  const nextSearch = params.toString();
  const nextUrl = `${pathname}${nextSearch ? `?${nextSearch}` : ""}${hash}`;
  window.history.replaceState({}, "", nextUrl);
  setStoredApiKey(key);
  return key;
};
